exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-expense td{vertical-align:middle}", ""]);

// exports
